import React from 'react';
import { createPortal } from 'react-dom';
import { LogIn } from 'lucide-react';
import './SessionExpiredModal.css';

export default function SessionExpiredModal({ open, onGoToLogin }) {
  if (!open) return null;

  const content = (
    <div
      className="session-expired-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-desc"
    >
      <div className="session-expired-dialog">
        <div className="session-expired-icon" aria-hidden>
          <LogIn size={28} strokeWidth={2.2} />
        </div>
        <h2 id="session-expired-title">Sesión expirada</h2>
        <p id="session-expired-desc">
          Tu sesión ha expirado o ya no es válida. Vuelve a iniciar sesión para continuar usando la aplicación.
        </p>
        <button type="button" className="session-expired-btn" onClick={onGoToLogin}>
          Ir a iniciar sesión
        </button>
      </div>
    </div>
  );

  return createPortal(content, document.body);
}
